import _ from 'lodash'
import { APP_SETTINGS } from '@/common/config'
import axiosIns from '@/libs/axios'
import useJwt from '@/auth/jwt/useJwt'
import SystemHelper from '@/common/systemHelper'

export const GET_MERCHANT_INTRODUCER_REPORT = 'getMerchantIntroducerReport'
export const SET_MERCHANT_INTRODUCER_REPORT = 'setMerchantIntroducerReport'

export default {
  namespaced: true,
  state: {
    introducerReport: null,
  },
  getters: {
    getRawData: state => key => {
      const data = state[key]
      if (data) {
        return data.list
      } return {}
    },
    getPaginationInfo: state => {
      const list = state.introducerReport
      if (list) {
        return list
      }
      return []
    },

    getIntroducerReport: state => {
      const currentState = state.introducerReport
      if (currentState) {
        const list = currentState.list.data
        if (Array.isArray(list) && list.length) {
          return list
        }
        return []
      }
      return []
    },
  },
  mutations: {
    [SET_MERCHANT_INTRODUCER_REPORT](state, val) {
      state.introducerReport = val
    },
  },
  actions: {
    // /account-introducer/merchant-introducer

    [GET_MERCHANT_INTRODUCER_REPORT](context, payload) {
      return new Promise((resolve, reject) => {
        const endpoint = 'account-introducer/merchant-introducer'

        axiosIns.post(`${APP_SETTINGS.BASE_URL + APP_SETTINGS.API_VERSION_NUM}${endpoint}`, payload)
          .then(res => {
            if (res.data.response_code === 2000) {
              useJwt.setToken(res.data.token)

              context.commit(SET_MERCHANT_INTRODUCER_REPORT, res.data.data)

              SystemHelper.successHandler(res)
              resolve(res)
            } else {
              SystemHelper.errorHandler(res)
              resolve(res)
            }
          })
          .catch(err => {
            SystemHelper.handleCatch()
            reject(err)
          })
      })
    },
  },
}
